<template>
<div class="container-fluid">
    <div class="row">
        <div class="col-xs-12">
            <div class="portlet light portlet-fit">
                <div class="portlet-title">
                    <div class="caption">
                        <i class="icon-calculator font-red-sunglo"></i>
                        <span class="caption-subject font-red-sunglo uppercase bold">Ajouter un tarif</span>
                    </div>
                </div>
                <div class="portlet-body">
                    <form role="form" class="form-group has-success">
                        <div class="form-group">
                            <tariff-select v-model="tariff.activity_type"></tariff-select>
                            <tariff-form
                                :tariff="tariff"
                                :edit="edit"
                                :paraglide="paraglide"
                                v-if="completed"
                                @storeTariff="storeTariff(tariff)"
                                @updateTariff="updateTariff(tariff)">
                            </tariff-form>
                        </div>
                        <div class="form-actions">
                            <button class="btn btn-danger" @click.prevent="reset" v-if="completed">Réinitialiser</button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
    <tariff-list :tariffs="tariffs" @editTariff="editTariff" @deleteTariff="deleteTariff" :paraglide="false">
        Récapitulatif des tarifs
    </tariff-list>
    <tariff-list v-if="userparapente" :tariffs="paragliderTariffs" @editTariff="editTariff" @deleteTariff="deleteTariff" :paraglide="true">
      Récapitulatif des tarifs parapente du bureau
    </tariff-list>
</div>
</template>

<script>
export default {
  name: 'tariffIndex',
  props: {
    office: {
      type: Object,
      default: () => {
        return {}
      }
    },
    userparapente: {
      type: Object,
      default: () => {
        return {}
      }
    },
    types: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      tariffs: this.getTariffs(),
      paragliderTariffs: this.getParagliderTariffs(),
      tariff: {
        activity_type: null,
        type: 'Collectif',
        office_id: this.office.id
      },
      edit: false,
    }
  },
  mounted() {
    Event.listen('type-selected', () => {
      this.completed = true
    })
  },
  computed: {
    completed: {
        get: function (){
            return this.tariff.activity_type != null
        },

        set: function (newValue) {
           return newValue
        }
    },
    paraglide: {

        get: function (){
            if (this.tariff.activity_type === "parapente") {
                return true
            }
            return false
        },

        set: function (newValue) {
            return newValue
        }

    }
  },
  methods: {
    reset() {
      this.edit = false
      this.tariff = {
        activity_type: null,
        public: "null",
        type: 'Collectif',
        office_id: this.office.id
      }
    },
    checkSelect() {
      if (this.tariff.activity_type == "null") {
        this.$snotify.info("Vous n'avez pas correctement rempli le formulaire.")
      }
    },
    getTariffs() {
      axios.get("/tariff/" + this.office.id).then(response => {
        this.tariffs = response.data.data
      })
    },
    getParagliderTariffs() {
      axios.get("/tariff/paraglider/" + this.office.id).then(response => {
        this.paragliderTariffs = response.data.data
      })
    },
    editTariff(tariff, paraglide) {
      this.completed = true
      this.paraglide = paraglide
      this.edit = true
      this.tariff = tariff
    },
    storeTariff(tariff) {
      this.send(tariff, 'post', `/tariff/store`)
    },
    updateTariff(tariff) {
      this.send(tariff, 'put', `/tariff/update/${tariff.id}`)
    },
    async send(tariff, method, path){
      const response = await axios[method](path, tariff)
      this.$snotify.success('Le tarif a été créé avec succès !')

      if (tariff.activity_type === 'parapente') {
        this.paragliderTariffs.push(response.data.tariff)
      } else if (method !== 'put') {
        this.tariffs.push(response.data.tariff)
      }

      this.reset()
    },
    deleteTariff(tariff, paraglide, index) {
      if (tariff.activity_type === "parapente") {
        axios.get("/tariff/paraglide/delete/" + tariff.id).then(response => {
          this.$snotify.success(response.data)
          this.$delete(this.paragliderTariffs, index)
        })
      } else {
        axios.get("/tariff/delete/" + tariff.id).then(response => {
          this.$snotify.success(response.data)
          this.$delete(this.tariffs, index)
        })
      }
    }
  }
}
</script>

<style lang="css" scoped>
</style>
